import { useCallback, useEffect, useState } from 'react';
import { Button, Chip, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { WalletTransactionService } from '../../services/WalletTransactionService';
import { getReferenceName } from '../../utils/walletTransactionReference';
import moment from 'moment';

const walletTransactionService = new WalletTransactionService();

const COLUMNS: CommonListColumn[] = [
    {
        label: 'Id',
        render: (row) => {
            const isPromotionalBalance = row?.referenceModelName === 'PROMOTIONAL_BALANCE';
            const isPaid = isPromotionalBalance && row?.expiresAt == null ? true : row?.isPaid;
            return (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                    <span>{row?.id}</span>
                    {isPaid && <Chip label="Paid" color="success" size="small" />}
                </div>
            );
        },
    },
    { label: 'Amount', field: 'amount' },
    { label: 'Wallet Id', field: 'userWalletId' },
    {
        label: 'Reference Id',
        render: (row) => (
            <Link href={`/#/${getReferenceName(row?.referenceModelName)}/${row?.referenceId}/show`}>
                {row?.referenceId}
            </Link>
        ),
    },
    { label: 'Reference Model Name', field: 'referenceModelName' },
    {
        label: 'Notes',
        render: (row) => row?.notes || '-',
    },
    {
        label: 'Created At',
        render: (row) =>
            row?.createdAt ? moment(row.createdAt).format('DD MMM YYYY hh:mm A') : '-',
    },
    {
        label: 'Updated At',
        render: (row) =>
            row?.updatedAt ? moment(row.updatedAt).format('DD MMM YYYY hh:mm A') : '-',
    },
    {
        label: 'Action',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/WalletTransactions/${row?.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

function CustomerWalletTransactions(props: any) {
    const { walletId } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        walletTransactionService
            .getAllWalletTransactionsForUser(walletId, rowsPerPage, rowsPerPage * page, {
                order: 'DESC',
                field: 'createdAt',
            })
            .then((res: any) => {
                setData(res?.data ?? []);
                setTotal(res?.count ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [walletId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyText="No Wallet Transactions Found"
        />
    );
}

export default CustomerWalletTransactions;
